import React, { useMemo } from "react";
import VideoTagsContainer from '../../Tags/VideoTagsContainer/VideoTagsContainer';
import TagHelper from '../../../helpers/PostHelpers/TagHelper';

const safeParseJSON = (value) => {
  if (typeof value !== 'string') {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const normalizeTagSource = (tagSource) => {
  if (!tagSource) {
    return [];
  }
  if (Array.isArray(tagSource)) {
    return tagSource;
  }
  if (Array.isArray(tagSource?.tags)) {
    return tagSource.tags;
  }
  if (typeof tagSource?.values === 'function') {
    const iterable = Array.from(tagSource.values());
    if (iterable.length) {
      return iterable;
    }
  }
  if (typeof tagSource === 'string') {
    const trimmed = tagSource.trim();
    if (!trimmed.length) {
      return [];
    }
    const parsed = safeParseJSON(trimmed);
    if (Array.isArray(parsed)) {
      return parsed;
    }
    if (Array.isArray(parsed?.tags)) {
      return parsed.tags;
    }
    if (parsed && typeof parsed === 'object') {
      return [parsed];
    }
    return trimmed
      .split(',')
      .map((tag) => tag.replace(/^[\[\{\"]+|[\]\}\"]+$/g, '').trim())
      .filter(Boolean);
  }
  if (typeof tagSource[Symbol.iterator] === 'function') {
    const iterableValues = Array.from(tagSource);
    if (iterableValues.length) {
      return iterableValues;
    }
  }
  return [tagSource];
};

const GameVideoDetails = ({ videoTagList, RightAction }) => {
  const normalizedTagList = useMemo(() => {
    const normalizedSource = normalizeTagSource(videoTagList);
    if (!normalizedSource.length) {
      return [];
    }
    return TagHelper.mergeTagLists(normalizedSource, []);
  }, [videoTagList]);

  const hasTags = normalizedTagList.length > 0;

  if (!hasTags && !RightAction) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3">
      {hasTags && <VideoTagsContainer videoTagList={normalizedTagList} />}
      {RightAction && <div className="mt-2">{RightAction}</div>}
    </div>
  );
};

export default GameVideoDetails;
